import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@ex/module/core/domain/base-component';

@Component({
  selector: 'enps-default',
  templateUrl: './enps-default.component.html',
  styleUrls: ['./enps-default.component.scss']
})
export class EnpsDefaultComponent extends BaseComponent implements OnInit {

  @Input('enpsAnalysis')
  enpsAnalysis: any;

  @Input('previousData')
  previousData: any;

  @Input('language')
  language = "EN"

  benchmark: any;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
